import classNames from 'classnames';
import { DateTime } from 'luxon';
import { User } from 'model';
import { IconCheckCircle, IconDeactivate, IconPause } from '../../components/QuirkIcons/index.js';
import styles from './UserStatus.module.css';
export const UserStatus: React.FC<{
	user: User | undefined;
	isSuspended: boolean;
}> = ({ user, isSuspended }) => {
	return (
		<>
			{user?.active ? (
				<div
					className={classNames({
						[styles.suspendedUser]: isSuspended,
						[styles.activeUser]: !isSuspended
					})}
				>
					{isSuspended ? (
						<>
							<div className="warningColor">
								<IconPause />
							</div>

							<div>User suspended until {DateTime.fromISO(user?.suspendedUntil || '').toFormat('f')}</div>
						</>
					) : (
						<>
							<div className="successColor">
								<IconCheckCircle />
							</div>

							<div>This user is active.</div>
						</>
					)}
				</div>
			) : (
				<div className={styles.deactivatedUser}>
					<div className="dangerColor">
						<IconDeactivate />
					</div>
					<div>This user is deactivated.</div>
				</div>
			)}
		</>
	);
};
